// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
const { getElement, getElements } = window.BAO.Utils
const { useArrows } = window.BAO.Carousel.plugins

class StoreHotspots extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.rooms = this.els.room.elements
    this.navButtons = [
      ...this.els.navButton.elements,
      ...(this.externalEls.navButton ? this.externalEls.navButton.elements : []),
    ]

    this.keys = this.dataset.keys.split(',')
    this.activeRoomKey = this.els.room.elements[0].dataset.key
  }

  connectedCallback () {
    this.setupListeners()

    this.imageResize()
    this.checkQueryStringOnLoad()
    this.initialiseDrawerCarousel()
    this.initialiseHeaderCarousel()

    this.els.room_scroll.elements.forEach(room => {
      this.horizontalDrag(room)
    })
  }

  setupListeners () {
    if (Shopify.designMode) {
      this.handleBlockSelect = this.handleBlockSelect.bind(this)
      this.imageResize = this.imageResize.bind(this)
      window.addEventListener('shopify:block:select', this.handleBlockSelect)
      window.addEventListener('shopify:section:load', this.imageResize)
    }

    window.addEventListener('resize', e => {
      this.imageResize()
    })

    this.handleNavButtonClick = this.handleNavButtonClick.bind(this)
    this.navButtons.forEach(button => {
      button.addEventListener('click', e => {
        this.handleNavButtonClick(e)
      })
    })
  }

  horizontalDrag (room) {
    const slider = room
    let isDown = false
    let startX
    let scrollLeft

    slider.addEventListener('mousedown', e => {
      isDown = true
      slider.classList.add('prd-StoreHotspots_RoomScroll-active')
      startX = e.pageX - slider.offsetLeft
      scrollLeft = slider.scrollLeft
    })

    slider.addEventListener('mouseleave', () => {
      isDown = false
      slider.classList.remove('prd-StoreHotspots_RoomScroll-active')
    })

    slider.addEventListener('mouseup', () => {
      isDown = false
      slider.classList.remove('prd-StoreHotspots_RoomScroll-active')
    })

    slider.addEventListener('mousemove', e => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - slider.offsetLeft
      const walk = (x - startX) * 3
      slider.scrollLeft = scrollLeft - walk
    })
  }

  imageResize () {
    const roomHeight = this.els.room.element.offsetHeight

    this.els.room_inner.elements.forEach(element => {
      element.style.height = `${roomHeight}px`
      element.style.width = `${16 * (roomHeight / 8)}px`
    })

    this.els.main.element.ariaBusy = 'false'
  }

  checkQueryStringOnLoad () {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    if (!params.has('room')) return

    const key = params.get('room')
    if (this.keys.includes(key)) this.loadNewRoom(key)
  }

  handleNavButtonClick (e) {
    const key = e.target?.dataset.navKey
    this.loadNewRoom(key)
  }

  handleBlockSelect (e) {
    const key = e.target?.dataset.key

    if (this.activeRoomKey !== key) this.loadNewRoom(key)
  }

  loadNewRoom (key) {
    this.activeRoomKey = key

    this.loadRoomImage()
    this.updateControls()
  }

  loadRoomImage () {
    this.rooms.forEach(room => {
      if (room.dataset.key === this.activeRoomKey) {
        room.removeAttribute('aria-hidden')
        this.updateRoomTabIndex(room, true)
      } else {
        room.setAttribute('aria-hidden', true)
        this.updateRoomTabIndex(room, false)
      }
    })
  }

  updateRoomTabIndex (parentElement, active) {
    parentElement.querySelectorAll('button').forEach(button => {
      button.tabIndex = active ? 0 : -1
    })
  }

  updateControls () {
    let headerSlideIndex
    this.navButtons.forEach(button => {
      if (button.dataset.navKey === this.activeRoomKey) {
        button.setAttribute('data-active', true)

        if (button.dataset.navIndex) {
          headerSlideIndex = parseInt(button.dataset.navIndex)
        }
      } else {
        button.removeAttribute('data-active')
      }
    })

    this.main.moveToIdx(headerSlideIndex)
  }

  initialiseHeaderCarousel () {
    if (this.els['header-slider']) {
      this.main = new KeenSlider(this.els['header-slider'].element, {
        selector: getElements(this.els['header-slide'].selector, {
          context: this.els['header-slider'].element,
        }),
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        created: () => {
          this.els['header-slider'].element.ariaBusy = 'false'
        },
      })

      this.main.slides.forEach((slide, idx) => {
        slide.addEventListener('click', () => {
          this.main.moveToIdx(idx)
        })
      })
    }
  }

  initialiseDrawerCarousel () {
    if (this.externalEls['drawer-slider']) {
      this.externalEls['drawer-slider'].elements.forEach(slider => {
        return new KeenSlider(
          slider,
          {
            selector: getElements(this.externalEls['drawer-slide'].selector, {
              context: slider,
            }),
            loop: true,
            slides: {
              origin: 'center',
              perView: 1,
            },
          },
          [
            carousel => {
              carousel.on('animationStarted', () => {
                const nextActiveIndex = carousel.track.absToRel(
                  carousel.animator.targetIdx || 0,
                )

                carousel.slides.forEach((slide, index) => {
                  slide.setAttribute('aria-current', index === nextActiveIndex)
                })

                this.activeIndex = nextActiveIndex
              })
            },
            useArrows({
              next: getElement(this.externalEls['drawer-next']?.selector, {
                context: slider.parentElement,
              }),
              previous: getElement(
                this.externalEls['drawer-previous']?.selector,
                {
                  context: slider.parentElement,
                },
              ),
            }),
          ],
        )
      })
    }
  }
}

if (!customElements.get('store-hotspots')) {
  customElements.define('store-hotspots', StoreHotspots)
}
